// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","primary":"#56CCF2","default":"#868686","wrapper":"_3XsH0OBSloni2g9RUFDLBb","menu":"_7NL6Nix7fYxkUGgEXJA6J"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Help/Help.mod.css
// module id = 598
// module chunks = 0